import axios from "axios";
import consts from "../consts";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";
import { setError, setErroAPI, setSuccess } from "../common/toast/toast";
import { getLista as getListaClienteComUC } from "../cliente/clienteActions";

export function setModoTela(modo, registro = {}) {
    return {
        type: "GESTAO_CREDITO_SOLAR_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setFiltro(filtro) {
    return {
        type: "GESTAO_CREDITO_SOLAR_FILTRO",
        payload: filtro,
    };
}

export function resetarFiltro() {
    return (dispatch, getState) => {
        dispatch({
            type: "GESTAO_CREDITO_SOLAR_RESETAR_FILTRO",
            payload: null,
        });
    };
}

export function setAguardando(aguardando) {
    return {
        type: "GESTAO_CREDITO_SOLAR_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = await axios.get(`${consts.API_URL}/cliente/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "GESTAO_CREDITO_SOLAR_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = await axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_usuario_logado=${usuarioLogado.id}&id_empresa=${idEmpresa}`);
            dispatch({
                type: "GESTAO_CREDITO_SOLAR_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaConcessionaria() {
    return async (dispatch, getState) => {
        try {
            const request = await axios.get(`${consts.API_URL}/concessionaria/listarSelect`);
            dispatch({
                type: "GESTAO_CREDITO_SOLAR_CONCESSIONARIA_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaGraficoGeracaoSaldo({ id_cliente, id_unidade_consumidora }) {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            dispatch({
                type: "GESTAO_CREDITO_SOLAR_GRAFICO_GERACAO_SALDO_LISTADO",
                payload: [],
            });
            const resp = await axios.get(
                `${consts.API_URL}/fatura/listarGraficoGeracaoSaldo?id_usuario_logado=${usuarioLogado.id}
			&id_cliente=${usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : id_cliente}
			&ids_unidades_consumidoras=${encodeURIComponent([id_unidade_consumidora])}&id_empresa=${idEmpresa}`
            );
            dispatch({
                type: "GESTAO_CREDITO_SOLAR_GRAFICO_GERACAO_SALDO_LISTADO",
                payload: resp,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export async function gerarRelatorio({ html, landscape, scale }) {
    return async (dispatch, getState) => {
        try {
            dispatch(setAguardando(true));
            const response = await axios.post(`${consts.API_URL}/relatorio`, { html, landscape, scale }, { responseType: "blob" });

            const reader = new FileReader();

            reader.onloadend = () => {
                const pdfBase64 = reader.result;
                dispatch(setArquivoPDF(pdfBase64, "Relatório.pdf", landscape ? "landscape" : "portrait"));
                dispatch(setAguardando(false));
            };

            reader.onerror = () => {
                console.error("Erro ao ler blob para base64");
                dispatch(setAguardando(false));
                setError("Erro ao processar o relatório");
            };

            reader.readAsDataURL(response.data);
        } catch (erro) {
            console.log(erro);
            dispatch(setAguardando(false)); // <<< chama aqui no catch também
            setError("Erro ao gerar o relatório");
        }
    };
}

export function getLista() {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};

        dispatch(setAguardando(true));
        try {
            const filtrarUsuarioImplantacao = usuarioLogado.usuario_implantacao;

            await Promise.all([dispatch(getListaConcessionaria()), dispatch(getListaCliente()), dispatch(getListaClienteComUC()), dispatch(getListaUnidadeConsumidora())]);

            //depois de carregar todos states define a variavel
            const state = getState().gestaoCreditoSolar;

            //separa apenas os clientes que alguma das ucs o usuário logado é o implantador, depois une todas UCs em que ele é o implantador em uma unica lista
            const listaUCsFiltradas = filtrarClientesUsuarioImplantacao(usuarioLogado, getState().cliente.lista).reduce((acc, cliente) => [...acc, ...cliente.itens], []);

            //se o usuario logado for implantador filtra as UCs do Select para listar apenas as que o usuário logado é o implantador
            const listaFiltradaUcsSelect = state.listaUnidadeConsumidora.filter((ucSelect) => {
                const filtrarImplantacao = !filtrarUsuarioImplantacao || listaUCsFiltradas.find((uc) => uc.id === ucSelect.id);

                return filtrarImplantacao;
            });
            const listaClienteFiltradaSelect = state.listaCliente.filter(
                (cliente) => !filtrarUsuarioImplantacao || listaUCsFiltradas.find((item) => item.id_cliente === cliente.id)
            );

            dispatch({
                type: "GESTAO_CREDITO_SOLAR_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: { data: listaFiltradaUcsSelect },
            });

            dispatch({
                type: "GESTAO_CREDITO_SOLAR_CLIENTE_SELECT_LISTADO",
                payload: { data: listaClienteFiltradaSelect },
            });

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;
            const filtroIdCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;
            const filtroUCMultiplo = filtrarIdsUnidadesConsumidoras({ filtro: state.filtro, listaUnidadeConsumidora: listaFiltradaUcsSelect });
            const filtroAno = state.filtro.ano;
            const filtroMes = state.filtro.mes;

            const resposta = await axios.get(
                `${consts.API_URL}/gestao-credito-solar?id_usuario_logado=${usuarioLogado.id}&id_cliente=${filtroIdCliente}&ids_unidades_consumidoras=${encodeURIComponent(
                    filtroUCMultiplo
                )}&ano=${filtroAno}&mes=${filtroMes}&id_empresa=${idEmpresa}`
            );
            const listaFaturas = resposta.data || [];

            const listaFaturasFiltrada = listaFaturas.filter((item) => !filtrarUsuarioImplantacao || listaFiltradaUcsSelect.find((uc) => item.id_unidade_consumidora === uc.id));

            dispatch({
                type: "GESTAO_CREDITO_SOLAR_LISTADO",
                payload: listaFaturasFiltrada,
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

function filtrarIdsUnidadesConsumidoras({ filtro, listaUnidadeConsumidora }) {
    const ids_unidades_consumidoras = filtro.unidades_consumidoras.map((item) => parseInt(item.value));

    const ucsFiltro = listaUnidadeConsumidora.filter((uc) => ids_unidades_consumidoras.includes(uc.id));

    //garante que a geradora de cada remota ta listada no filtro, pra não listar uma remota sem sua geradora
    for (const uc of ucsFiltro) {
        //se a geradora dela nao ta na lista, adiciona
        if (uc.id_unidade_geradora && !ucsFiltro.find((item) => item.id == uc.id_unidade_geradora)) {
            const geradora = listaUnidadeConsumidora.find((item) => item.id == uc.id_unidade_geradora);
            if (geradora) {
                ids_unidades_consumidoras.push(geradora.id);
                filtro.unidades_consumidoras.push({ value: "" + geradora.id, label: geradora.valor });
            }
        }
    }

    //traz a uc do filtro se for geradora, e traz juntos as remotas que dependem dela
    const ids_unidades_consumidoras_filtrados = listaUnidadeConsumidora
        .filter((uc) => {
            const ucEstaNoFiltro = ids_unidades_consumidoras.includes(uc.id);
            const ucGeradoraNoFiltro = ids_unidades_consumidoras.includes(uc.id_unidade_geradora);
            const temUcRemotaNoFiltro = listaUnidadeConsumidora.filter((unidade) => ids_unidades_consumidoras.includes(unidade.id)).find((unidade) => unidade.id_unidade_geradora);
            return ucEstaNoFiltro || (!temUcRemotaNoFiltro && !ucEstaNoFiltro && uc.id_unidade_geradora && ucGeradoraNoFiltro);
        })
        .map((uc) => uc.id);

    //se selecionou alguma UC manda a lista de ids das UCs selecionadas
    if (ids_unidades_consumidoras_filtrados.length) {
        return ids_unidades_consumidoras_filtrados;
    }

    //se nenhum filtro tiver sido alterado manda nulo para trazer todas UCs
    if (!filtro.id_grupo_faturamento) return null;

    //se não tiver nenhuma UC selecionada, filtra a lista de UC original de acordo com os filtros selecionados
    const listaFiltrada = listaUnidadeConsumidora
        .filter((item) => {
            const filtrarCliente = !filtro.id_cliente || item.id_cliente == filtro.id_cliente;
            const filtrarGrupoFaturamento = !filtro.id_grupo_faturamento || item.id_grupo_faturamento == filtro.id_grupo_faturamento;

            return filtrarCliente && filtrarGrupoFaturamento;
        })
        .map((item) => item.id);

    return listaFiltrada.length ? listaFiltrada : [0];
}

//retorna uma lista de com os clientes cujo o usuario logado é o implantador
//cada cliente tem apenas as UCs do usuário implantador
function filtrarClientesUsuarioImplantacao(usuarioLogado, listaClientes) {
    const clientesFiltrados = listaClientes.filter((cliente) => cliente.itens.find((uc) => uc.id_usuario_implantacao === usuarioLogado.id));
    const clientesComUCsFiltradas = clientesFiltrados.map((cliente) => {
        const unidadesConsumidoras = cliente.itens.filter((uc) => {
            return uc.id_usuario_implantacao === usuarioLogado.id;
        });
        return { ...cliente, itens: unidadesConsumidoras };
    });
    return clientesComUCsFiltradas;
}
